// extracted by mini-css-extract-plugin
module.exports = {"radio":"jgp-1vDmz"};